import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTagModule, FreudTooltipModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { SpeechToTextComponent } from './speech-to-text.component';

@NgModule({
	declarations: [SpeechToTextComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTooltipModule,
		FreudTagModule,
	],
	exports: [SpeechToTextComponent],
	providers: [],
})
export class SpeechToTextModule {}
